var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.041,
    height: 22.033,
    viewBox: "0 0 21.041 22.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Home_3367736",
    transform: "translate(-5.071 -4.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M25.86,14.412,16.266,4.818a.959.959,0,0,0-1.343,0L5.329,14.412a.959.959,0,0,0,.633,1.612h1.17v9.594a.959.959,0,0,0,.959.959h5.372V20.139a.959.959,0,0,1,.959-.959h2.322a.959.959,0,0,1,.959.959v6.428h5.372a.959.959,0,0,0,.959-.959V16.014h1.218a.959.959,0,0,0,.6-1.6Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.96ea9b4aca84804f73945ce1ce699b0f.svg";
export { ForwardRef as ReactComponent };